import { TeamAccessDTO } from '../team/team-access.dto';

export class PricelistListDTO extends TeamAccessDTO {

    id: string;

    name: string;

    description: string;

    currency: string;
    
}
